import * as Updates from "expo-updates";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import RText from "./RText";
import { APP_ENV } from "../client";
import { getDeviceId } from "../utils/getDeviceId";

export const AppInfo = () => {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    getDeviceId().then((id) => setDeviceId(id));
  }, []);

  // Helper to format the patch time in “Thu, 05 Jun 11:48” (BST/GMT aware)
  const formatPatchTime = () => {
    if (!Updates.createdAt) return "";
    const d = new Date(Updates.createdAt);
    const datePart = d.toLocaleDateString("en-GB", {
      timeZone: "Europe/London",
      weekday: "short",
      day: "2-digit",
      month: "short",
    });
    const timePart = d.toLocaleTimeString("en-GB", {
      timeZone: "Europe/London",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return `${datePart} ${timePart}`;
  };

  // Row style: two columns, label on the left, value on the right
  const rowStyle = {
    flexDirection: "row" as const,
    justifyContent: "space-between" as const,
    marginVertical: 2,
  };

  return (
    <View style={{ padding: 10 }}>
      <View style={rowStyle}>
        <RText color="grey">Patch Time</RText>
        <RText color="grey">{formatPatchTime()}</RText>
      </View>

      <View style={rowStyle}>
        <RText color="grey">DeviceID</RText>
        <RText color="grey">{deviceId?.split("-")?.pop() || deviceId}</RText>
      </View>

      <View style={rowStyle}>
        <RText color="grey">Version</RText>
        <RText color="grey">
          {APP_ENV}-{Updates.updateId ? Updates.updateId.split("-").pop() : ""}
        </RText>
      </View>
    </View>
  );
};
